module.exports = __webpack_public_path__ + "static/media/ChatBot.8b905955.svg";